import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { ToastContainer } from 'react-toast'
import App from 'App'

import { GlobalStateProvider } from 'globalState'
import './i18n'
import ThemeProvider from './provider/ThemeProvider'
import Spinner from './components/Spinner'
import LocaleProvider from 'context/locale.context'

console.log = function() {}
console.warn = function() {}
console.error = function() {}

ReactDOM.render(
  <Suspense fallback={<Spinner />}>
    <GlobalStateProvider>
      <ThemeProvider>
        <LocaleProvider>
          <App />
        </LocaleProvider>
      </ThemeProvider>
      <ToastContainer position="top-right" delay={4000} />
    </GlobalStateProvider>
  </Suspense>,
  document.getElementById('root')
)
